import { ReactNode } from 'react';
import styles from './Layout.module.css';

const Header = ({ children }: { children: ReactNode }) => {
  return <div className={styles.header}>{children}</div>;
};
const Content = ({ children }: { children: ReactNode }) => {
  return <div className={styles.content}>{children}</div>;
};

const Sider = ({ children }: { children: ReactNode }) => {
  return <div className={styles.sider}>{children}</div>;
};

const Layout = ({ children }: { children: ReactNode }) => {
  return <div className={styles.layout}>{children}</div>;
};

Layout.Header = Header;
Layout.Content = Content;
Layout.Sider = Sider;

export default Layout;
